import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age'
})
export class PipePipe implements PipeTransform {

    // transform(value : Date): any {
    //     const today = new Date();
    //     const DOB = new Date(value);  
    //     var totalMonths = (today.getFullYear() - DOB.getFullYear()) * 12 + today.getMonth() - DOB.getMonth();
    //     totalMonths += today.getDay() < DOB.getDay() ? -1 : 0;
    //     var years = today.getFullYear() - DOB.getFullYear();
    //     if (DOB.getMonth() > today.getMonth())
    //         years = years - 1;
    //     else if (DOB.getMonth() === today.getMonth())
    //         if (DOB.getDate() > today.getDate())
    //             years = years - 1;

    //     var days;
    //     var months;

    //     if (DOB.getDate() > today.getDate()) {
    //         months = (totalMonths % 12);
    //         /*if (months == 0)
    //         months = 11;*/
    //         var x = today.getMonth();
    //         switch (x) {
    //             case 1:
    //             case 3:
    //             case 5:
    //             case 7:
    //             case 8:
    //             case 10:
    //             case 12: {
    //                 var a = DOB.getDate() - today.getDate();
    //                 days = 31 - a;
    //                 break;
    //             }
    //             default: {
    //                 var a = DOB.getDate() - today.getDate();
    //                 days = 30 - a;
    //                 break;
    //             }
    //         }   

    //     }
    //     else {
    //         days = today.getDate() - DOB.getDate();
    //         if (DOB.getMonth() === today.getMonth())
    //             months = (totalMonths % 12);
    //         else
    //             months = (totalMonths % 12) ;
    //     }
    //     var age = years + 'y ' + months + 'm'
    //     return age;
    // }

    transform(value: Date): any {
        const today = new Date();
        const DOB = new Date(value);
    
        let years = today.getFullYear() - DOB.getFullYear();
        let months = today.getMonth() - DOB.getMonth();
        let days = today.getDate() - DOB.getDate();
    
        if (days < 0) {
            months--;
            const lastMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
            days += lastMonth;
        }
    
        if (months < 0) {
            years--;
            months += 12;
        }
    
        const age = years + 'y ' + months + 'm';
        return age;
    }


    // transform(dob : Date): any {
    //     const birthDate = new Date(dob);
    //     const currentDate = new Date();

    //     let years = currentDate.getFullYear() - birthDate.getFullYear();
    //     let months = currentDate.getMonth() - birthDate.getMonth();

    //     if (months < 0) {
    //     years--;
    //     months += 12;
    //     }

    //     // Add fractional part of the year based on months
    //     const ageInYears = years + months / 12;

    //     return `${ageInYears.toFixed(2)} Year(s)`;
    // }


  // transform(value : Date): any {
  //   const currentYear = new Date().getFullYear();
  //    const dobYear = new Date(value).getFullYear();     
  //    const age = currentYear - dobYear;
  //   return age ;
  // }
 

}



 